import styled from 'styled-components';

export const StyledList = styled.div`
  display: table;
  width: 100%;
`;
